import { hasIntegrationAtom } from '@/atoms/integrationAtoms';
import { IntegrationUpgradeModal } from '@/components/modal/heidi-pro-modal/integration-upgrade-modal';
import useQueryUserTier from '@/hooks/query/useQueryUserTier';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';

export default function IntegrationPaywall() {
  const [showIntegrationUpgradeModal, setShowIntegrationUpgradeModal] = useState(false);
  const { isAuthenticated } = useIsAuthenticated();
  const hasIntegration = useAtomValue(hasIntegrationAtom);
  const { userTier } = useQueryUserTier();

  useEffect(() => {
    const shouldShowIntegrationUpgradeModal = Boolean(
      isAuthenticated &&
      hasIntegration &&
      userTier &&
      (userTier === SubscriptionTier.FREE || userTier === SubscriptionTier.PRO)
    );

    setShowIntegrationUpgradeModal(shouldShowIntegrationUpgradeModal);
  }, [isAuthenticated, userTier, hasIntegration]);

  return (
    <IntegrationUpgradeModal
      open={showIntegrationUpgradeModal}
      shouldBlurOverlay
      hideOverlay={false}
      // Note: not sure where this is component is used but setting it to PRO_PLUS should make it work the same as before
      tierToUpgrade={SubscriptionTier.PRO_PLUS}
    />
  );
}
